import { alerts } from "keys"
import SchoolClasses from 'pages/School/AffiliationManagement/SchoolClasses'
import LearningGroups from 'pages/School/AffiliationManagement/LearningGroups'

const useAffiliationGroupItems = () => {

    const groupTabByName = {
        "בתי ספר": {
            createButtonLabel: "הוספת בית ספר",
            alertKey: alerts.addSchoolClass,
            createClassLabel: "הוספת שכבה וכיתה",
            LearningUnitComponent: SchoolClasses
        },
        "קליניקות": {
            createButtonLabel: "הוספת קליניקה",
            alertKey: alerts.addLearningGroup,
            createClassLabel: "הוספת קבוצה",
            LearningUnitComponent: LearningGroups
        },
        "פרטיים": {
            createButtonLabel: "הוספת לקוח פרטי",
            alertKey: alerts.addLearningGroup,
            createClassLabel: "הוספת קבוצה",
            LearningUnitComponent: LearningGroups
        },
        "מרכזי למידה": {
            createButtonLabel: "הוספת מרכז למידה",
            alertKey: alerts.addLearningGroup,
            createClassLabel: "הוספת קבוצה",
            LearningUnitComponent: LearningGroups
        }
    }

    return groupTabByName
}

export default useAffiliationGroupItems

